<template>
  <validation-provider
    #default="{ errors }"
    :name="inputId"
    :vid="inputId"
    :rules="customRules"
    :custom-messages="customMessages"
  >
    <b-form-group :label="inputLabel" :label-for="inputId">
      <b-input-group>
        <b-form-input
          :readonly="readonly"
          :disabled="disabled"
          :type="type"
          :inputmode="inputmode"
          trim
          :id="inputId"
          :value="value"
          :state="errors.length > 0 ? false : null"
          class="d-inline-block"
          :placeholder="inputPlaceholder"
          @input="$emit('input', $event)"
          @keydown.enter="emitEnterKeydown"
        />
        <b-input-group-append :is-text="isText">
          <slot name="append"></slot>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </validation-provider>
</template>
<script>
export default {
  emits: ["enter"],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    isText: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    inputmode: {
      type: String,
      default: "text",
    },
    errorMessage: {
      type: [String, null],
      default: "این فیلد اجباری است.",
    },
    customRules: {
      type: [String, null],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      required: false,
      default: "textValue",
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String, null],
      default: "وارد کنید",
    },
    inputPlaceholder: {
      type: [String, null],
      default: "وارد کنید",
    },
    customMessages: {
      type: Object,
      default: () => {
        return {
          required: "{_field_} اجباری است",
          min: "{_field_} حداقل باید {length} حرف باشد",
          between: "{_field_} باید بین {min} و {max} باشد",
        };
      },
    },
  },
  data() {
    return {
      required,
    };
  },
  methods: {
    emitEnterKeydown() {
      this.$emit("enter");
    },
  },
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    ValidationProvider,
  },
};
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import {
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
} from "bootstrap-vue";
</script>
